import React, {Component} from 'react';
import {Route, Switch} from "react-router-dom";
import HomePage from "./app/home/HomePage";
import PageNotFound from "./app/page-not-found/PageNotFound";
import Header from "./shared-components/Header";

class App extends Component {
    render() {
        return (
            <div id="app">
                <Header/>

                <Switch>
                    <Route exact path="/" component={HomePage}/>

                    <Route component={PageNotFound}/>
                </Switch>
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js